import React from 'react';
import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';
import style from './InStopCheckbox.module.scss';

interface IProps {
	toggleInStop: () => void;
	inStop: boolean;
	isDisabled: boolean;
}

export const InStopCheckbox: React.FC<IProps> = React.memo(({ toggleInStop, inStop, isDisabled }) => {
	return (
		<Form.Item className={style.container} name="inStop" data-test="InStopCheckbox">
			<Checkbox onChange={toggleInStop} checked={inStop} disabled={isDisabled}>
				<Text translationNameSpace="form" translationKey="inStopLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
});
